import { faAngleDoubleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDoubleDown";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Typography } from "@mui/material";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Drawer from "@mui/material/Drawer";
import Icon from "@mui/material/Icon";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { withStyles, WithStyles } from "@mui/styles";
import * as coreApi from "api/Core";
import { GlobalClassKeys } from "assets/jss/common-styles";
import sidebarStyle from "assets/jss/layouts/dashboard/sidebarStyle";
import classNames from "classnames";
import { SpinnerIndicator } from "components/CallServer";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import IconCircle from "components/Icons/IconCircle";
import IconQRCode from "components/Icons/IconQRCode";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import i18next from "i18next";
import { WindowMessageListener } from "lib/WindowMessageListener";
import { DynamicSystemRoles } from "models/ApiEnums";
import { IDashboardFloatMenu, IDashboardFloatMenuItem, IDashboardMenu } from "models/AppModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import ReactResizeDetector from "react-resize-detector";
import { NavLink } from "react-router-dom";
import { Action, bindActionCreators } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import Session from "services/Session";
import * as AppActions from 'store/app/actions';
import { ApplicationState } from 'store/rootReducer';
import * as SideBarActions from 'store/sidebar/actions';
import { SideBarState } from 'store/sidebar/reducer';
import { SidebarMessageTypes } from "store/sidebar/windowMessages";
import UserMobileQrCode from "views/User/Dialogs/UserMobileQrCode";
import "./perfect-scrollbar.css";
////////////////////////////////////////////////////////////////////////////////////////////////////

type IDispatchProps = typeof SideBarActions & typeof AppActions;

interface IStateProps {
    sidebar: SideBarState;
}

interface IState {
    activeMenu: IFindMenu;
    dialog: any;
    open?: boolean;
}

interface IProps {
    observerRightComponentId?: string;
    path: string;
}

interface IFindMenu {
    left: IDashboardMenu;
    right: IDashboardFloatMenuItem;
    hasFloatMenu: boolean;
    parcialPath: boolean;
}

type Props = IProps & WithTranslation & IStateProps & IDispatchProps & WithStyles<typeof sidebarStyle>;

////////////////////////////////////////////////////////////////////////////////////////////////////

class SidebarWindowMessageListener extends WindowMessageListener<SidebarMessageTypes> {
}

////////////////////////////////////////////////////////////////////////////////////////////////////

class Sidebar extends React.PureComponent<Props, IState> {
    private currentWidth: number;
    private wml: SidebarWindowMessageListener;
    private counterTimer: any = null;
    private lockedActiveMenu: boolean = false;

    constructor(props: Props) {
        super(props);
        this.state = {
            activeMenu: null,
            dialog: null,
            open: null
        };
    }

    //
    private bellowMinWidth(): boolean {
        var w = 0;
        if (this.props.observerRightComponentId) {
            const infoBox = document.getElementById(this.props.observerRightComponentId);
            if (infoBox) w = parseInt(window.getComputedStyle(infoBox, null).getPropertyValue("width"));
        }

        return this.currentWidth <= (961 + w);
    }

    //
    private applySidebarMargin(bellowMinWidth: boolean) {
        if (bellowMinWidth || !this.state.activeMenu.hasFloatMenu) document.getElementsByTagName("body")[0].classList.remove("menuOpen");
        else document.getElementsByTagName("body")[0].classList.add("menuOpen");
    }

    //
    private checkSidebarMustBeOpened() {
        if (this.props.sidebar.menuData.length != 0) {

            const bellowMinWidth = this.bellowMinWidth();
            const mustBeOpened = !bellowMinWidth && this.state.activeMenu.hasFloatMenu;

            if (this.state.open != mustBeOpened) {
                this.setState({ open: mustBeOpened });
            }

            this.applySidebarMargin(bellowMinWidth);
        }
    }

    //
    private findMenuFromPath(data: IDashboardMenu[], path: string): IFindMenu {

        var result: IFindMenu = { left: null, right: null, hasFloatMenu: false, parcialPath: false };

        data.some((r) => {
            if (r.groups != null) {

                // Procura no grupo por paths exatos.
                r.groups.some((g) => {

                    // O path est� em algum dos items?
                    var groupItem = g.items.find(i => i.path != null && i.path == path);
                    if (groupItem != null || (g.groupButton && g.groupButton.path == path)) {
                        result.left = r;
                        result.right = groupItem;
                        result.hasFloatMenu = true;
                        return true;
                    }

                    return false;
                });

                // Se n�o encontrou, verifica paths parciais.
                if (result.left == null && path.indexOf(r.navbarPath) > -1) {
                    result.left = r;
                    result.hasFloatMenu = r.groups.length > 0;

                    // Verfica paths parciais no grupo
                    r.groups.some((g) => {

                        var groupItem = g.items.find(i => path.indexOf(i.path) > -1);
                        if (groupItem != null || (g.groupButton && g.groupButton.path.indexOf(path) > -1)) {
                            result.left = r;
                            result.right = groupItem;
                            result.parcialPath = true;
                            return true;
                        }
                        return false;
                    });
                }

                return result.left != null;
            }
            else {
                if (path == r.navbarPath) {
                    result.left = r;
                }
            }

            return result.left != null;
        });

        return result;
    }

    //
    private findByName(routeName: string): IFindMenu {
        var result: IFindMenu = { left: null, right: null, hasFloatMenu: false, parcialPath: false };

        this.props.sidebar.menuData.some((r) => {
            if (routeName == r.navbarName) {
                result.left = r;
                result.hasFloatMenu = r.groups != null;
                return true;
            }
            return false;
        });

        return result;
    }

    //
    private handleQrCode = () => {
        this.setState({
            dialog: (
                <UserMobileQrCode
                    onClose={() => this.setState({ dialog: null })}
                />)
        });
    };

    //
    private handleItemClick(routeName: string, routePath: string) {

        const { activeMenu } = this.state;
        const { sidebar: { menuData }, path } = this.props;

        // Se o menu est� escondido, abre para exibir o menu flutuante.
        if (this.bellowMinWidth() &&
            (routeName == null || (activeMenu.left != null && routeName == activeMenu.left.navbarName && activeMenu.hasFloatMenu))) {
            this.setState({ open: !this.state.open });
        }
        else if (activeMenu.left == null || routeName != activeMenu.left.navbarName) {

            // Encontra novo menu baseado no RoutePath
            let newActiveMenu = routePath != null
                ? this.findMenuFromPath(menuData, routePath)
                : this.findByName(routeName);

            // Se o menu flutuante n�o foi encontrado, 
            // verificar se � poss�vel encontr�-lo com o Path atual.
            if (newActiveMenu.right == null && path.indexOf(routePath) > -1) {
                const menu = this.findMenuFromPath(menuData, path);
                if (menu != null) newActiveMenu = menu;
            }

            this.setState({
                open: newActiveMenu.hasFloatMenu,
                activeMenu: newActiveMenu
            }, () => this.updateCurrentMenuName());
        }
    }

    //
    private handleClickOuter(e: MouseEvent | TouchEvent) {

        // Reflete novamente a op��o do menu que est� ativa
        const menu = this.findMenuFromPath(this.props.sidebar.menuData, this.props.path);

        // Reavalia se deve ou n�o fechar o menu flutuante.
        const keepOpen = this.bellowMinWidth() || !menu.hasFloatMenu
            ? false
            : this.state.open;

        this.setState({
            activeMenu: menu,
            open: keepOpen
        }, () => this.updateCurrentMenuName());
    }

    //
    private handleResize(width: number, height: number): void {
        this.currentWidth = width;
        this.checkSidebarMustBeOpened();
    }

    //
    private setActiveMenu(props: Props) {
        if (this.lockedActiveMenu) return;

        const menu = this.findMenuFromPath(props.sidebar.menuData, props.path);
        this.setState({
            activeMenu: menu,
        }, () => this.updateCurrentMenuName());
    }

    //
    private updateCurrentMenuName() {
        const menu = this.state.activeMenu;
        if (menu.left != null && (!menu.hasFloatMenu || menu.right != null)) {
            var mainContent = document.getElementsByTagName("main");
            if (mainContent?.length == 1) mainContent[0].setAttribute("aria-label", (menu.right ? (menu.right.name + " - ") : "") + menu.left.navbarName);
        }
    }

    //
    private renderGroup(g: IDashboardFloatMenu, activeRoute: IFindMenu) {
        const { classes } = this.props;

        if (g.listThreshold == null) {
            // Lista n�o paginada
            const itemsOrdered = g.items.sort((a, b) => (a.grouping || 0) - (b.grouping || 0));
            let go = itemsOrdered[0].grouping;
            return itemsOrdered.map((item, index) => {

                if (item.grouping != go) {
                    go = item.grouping;
                    return <React.Fragment key={index} ><br />{this.renderGroupItem(activeRoute, item)}</React.Fragment>;
                }

                return this.renderGroupItem(activeRoute, item);
            });
        }

        // Lista paginada
        const azText = i18next.t("Common.Literals.FullListAZ");
        const moreText = i18next.t("Common.Literals.MoreText");
        const always = g.items.filter(p => p.showMode !== "temp");
        const tempData = g.items.filter(p => p.showMode == "temp");
        const foundMenuIndex = this.state.activeMenu.right == null ? -1 : tempData.findIndex(p => p.path == this.state.activeMenu.right.path);
        const maxItems = (foundMenuIndex > -1 ? Math.max(foundMenuIndex, g.listCurrentIndex) : g.listCurrentIndex) + g.listThreshold;
        const hasMore = maxItems < tempData.length;
        const moreString = (tempData.length - maxItems > 1) ? `${moreText} ${tempData.length - maxItems} ${g.listOverflowName}` : `${moreText} ${tempData.length - maxItems} ${g.listOverflowNameSingular}`;
        const tempList = tempData.filter((v, index) => index < maxItems);

        return (
            <>
                {always.filter(p => p.showMode == "regular").map((item) => this.renderGroupItem(activeRoute, item))}

                {
                    tempData.length > 0 && g.listCurrentIndex == -1
                        ? (
                            <ListItem
                                button
                                disableGutters
                                className={classes.floatListItem}
                                onClick={
                                    () => {
                                        this.lockedActiveMenu = true;
                                        this.props.updateGroupListItems(g.group, 0);
                                    }
                                }
                            >
                                <ListItemIcon className={classNames(classes.floatIcon, classes.floatIconLeftWrapper)} >
                                    <FontAwesomeIcon icon={faAngleDoubleDown} fixedWidth />
                                </ListItemIcon>

                                <ListItemText
                                    primary={azText}
                                    primaryTypographyProps={
                                        {
                                            variant: "body2",
                                            noWrap: true,
                                            className: classes.floatTextColor
                                        }
                                    }
                                />
                            </ListItem>
                        )
                        : tempData.length > 0
                            ? (
                                <>
                                    {
                                        g.listUseDivider &&
                                        <div className={classes.azDivider}><Typography variant="caption">&nbsp;A-Z</Typography></div>
                                    }

                                    {tempList.map((item) => this.renderGroupItem(activeRoute, item))}

                                    {
                                        hasMore
                                            ? (
                                                <ListItem
                                                    button
                                                    disableGutters
                                                    className={classes.floatListItem}
                                                    onClick={
                                                        () => {
                                                            this.lockedActiveMenu = true;
                                                            this.props.updateGroupListItems(g.group, maxItems + g.listThreshold);
                                                        }
                                                    }
                                                >
                                                    <ListItemIcon className={classNames(classes.floatIcon, classes.floatIconLeftWrapper)} >
                                                        <FontAwesomeIcon icon={faAngleDoubleDown} fixedWidth />
                                                    </ListItemIcon>

                                                    <ListItemText
                                                        primary={moreString}
                                                        primaryTypographyProps={
                                                            {
                                                                variant: "body2",
                                                                noWrap: true,
                                                                className: classes.floatTextColor
                                                            }
                                                        }

                                                    />
                                                </ListItem>
                                            )
                                            : null
                                    }

                                </>
                            )
                            : null
                }

                {always.filter(p => p.showMode == "bottom").map((item) => this.renderGroupItem(activeRoute, item))}
            </>
        );
    }

    //
    private renderGroupItem(activeRoute: IFindMenu, item: IDashboardFloatMenuItem) {

        // Exclui item de menu conforme regras "hideIf..."
        if (
            (item.hideIfNoCallout === true && item.callout !== true)
            ||
            (item.hideIfNoCanViewCourses === true && !Session.hasDynamicRole(DynamicSystemRoles.HasOrCanViewCourses))
        ) {
            return null;
        }


        const { classes } = this.props;
        const routeActived = activeRoute.right && activeRoute.right.path == item.path && !activeRoute.parcialPath && activeRoute.right.alternativeActionItem !== true;
        const routeParcial = activeRoute.right && activeRoute.right.path == item.path && activeRoute.parcialPath && activeRoute.right.alternativeActionItem !== true;

        const selectedClasses = classNames({
            [classes.floatActiveItem]: routeActived,
        });

        const textClasses = classNames({
            [classes.activeRouteText]: routeActived,
            [classes.activeParcialRouteText]: routeParcial,
        });

        const key = "sidebar-" + item.name;

        return (
            <NavLink
                to={item.path}
                className={classes.navlinkItem}
                activeClassName={selectedClasses}
                key={key}>
                <ListItem
                    button
                    dense
                    disableGutters
                    tabIndex={2}
                    className={classNames(classes.floatListItem, selectedClasses)}
                    aria-selected={routeActived || routeParcial}
                    onClick={() => { this.handleItemClick(activeRoute.left.navbarName, item.path); }}
                >
                    <ListItemIcon className={classNames(textClasses, classes.floatIcon, classes.floatIconLeftWrapper)}
                    >
                        {typeof item.icon === "string"
                            ? (<img src={item.icon} height={16} width={16} alt={item.name} />)
                            : (<FontAwesomeIcon icon={item.icon} size="lg" fixedWidth />)}
                    </ListItemIcon>

                    <ListItemText
                        title={item.name}
                        primary={item.name}
                        primaryTypographyProps={
                            {
                                variant: "body2",
                                noWrap: true,
                                className: classNames(textClasses, classes.floatTextColor)
                            }
                        }
                    />

                    {
                        item.callout === true &&
                        <ListItemIcon className={classes.floatIconRightWrapper}>
                            <MuiColor variant="warning"><IconCircle fixedWidth /></MuiColor>
                        </ListItemIcon>
                    }

                </ListItem>
            </NavLink>
        );
    }

    //
    private renderSubHeader(g: IDashboardFloatMenu) {
        const { classes } = this.props;

        if (g.groupButton == null)
            return (
                <div className={classes.subHeader}>
                    <span>{g.group}</span>
                </div>
            );

        return (
            <Grid container justifyContent="space-between" alignContent="center" wrap="nowrap" className={classes.subHeader} tabIndex={2}>
                <Grid item>
                    <span>{g.group}</span>
                </Grid>
                <Grid item className={classes.floatIcon} >
                    <NavLink
                        to={g.groupButton.path}
                        className={classes.floatIconRightWrapper}
                    >
                        <FontAwesomeIcon icon={g.groupButton.icon} title={g.groupButton.title} />
                    </NavLink>
                </Grid>
            </Grid>
        );
    }

    //
    private spacer(flag: boolean) {
        return flag === true
            ? <div className={this.props.classes.prependSpacer} tabIndex={-1}></div>
            : null;
    }

    //
    private getLeftMenu(navbarName: string) {
        const { classes } = this.props;

        return (
            <List
                className={classes.list}
                component="div"
                tabIndex={1}
            >
                {this.props.sidebar.menuData.map((leftMenu, key) => {

                    const routeActived = navbarName && navbarName == leftMenu.navbarName;

                    var listItemClasses = classNames({
                        [classes.listItem]: true,
                        [classes.activeRoute]: routeActived,
                    });

                    var listIconClasses = classNames({
                        [classes.activeRouteText]: true
                    });

                    const listItem = (
                        <ListItem
                            button
                            disableGutters
                            className={listItemClasses}
                            title={leftMenu.navbarName}
                            tabIndex={1}
                            aria-selected={routeActived}
                            aria-expanded={routeActived && leftMenu.navbarPath != null && leftMenu.groups.length > 0}
                            onClick={() => { this.handleItemClick(leftMenu.navbarName, leftMenu.navbarPath); }}
                        >
                            <ListItemIcon
                                className={listIconClasses}
                            >
                                <>
                                    {
                                        typeof leftMenu.navbarIcon === "string"
                                            ? (<Icon>{leftMenu.navbarIcon}</Icon>)
                                            : (<FontAwesomeIcon icon={leftMenu.navbarIcon} fixedWidth />)
                                    }
                                    {
                                        leftMenu.callout === true &&
                                        <span className={classes.notifications}><MuiColor variant="warning"><IconCircle fixedWidth /></MuiColor></span>
                                    }
                                </>
                            </ListItemIcon>

                        </ListItem>
                    );

                    return (leftMenu.navbarPath == null || leftMenu.groups.length > 0)
                        ? (
                            <React.Fragment key={key}>
                                {this.spacer(leftMenu.prependSpacer)}{listItem}
                            </React.Fragment>
                        )
                        : (
                            <React.Fragment key={key}>
                                {this.spacer(leftMenu.prependSpacer)}
                                <ListItem
                                    button
                                    disableGutters
                                    tabIndex={1}
                                    className={classes.listItemSingle}
                                >
                                    <NavLink
                                        to={leftMenu.navbarPath}
                                        className={classes.navlinkItem}
                                    >
                                        {listItem}
                                    </NavLink>
                                </ListItem>
                            </React.Fragment>
                        );
                })}
            </List>
        );
    }

    //
    private getFloatMenu(activeRoute: IFindMenu) {
        if (activeRoute == null || activeRoute.left == null || activeRoute.left.groups == null)
            return null;

        const { classes } = this.props;

        return (

            <Drawer
                variant="permanent"
                className={this.state.open ? classes.show : classes.hide}
                classes={{ paper: classes.drawerPaper2 }}
                tabIndex={2}
            >
                <PerfectScrollbar option={{ scrollingThreshold: 4 }}>
                    <div>
                        {
                            activeRoute.left.groups.map((g, key) => {
                                return g.loader != null && g.loading
                                    ? (
                                        <List component="nav" className={classes.list} key={key} tabIndex={2}>
                                            {this.renderSubHeader(g)}
                                            <SpinnerIndicator />
                                        </List>
                                    )
                                    : g.loader != null && g.loaderError != null
                                        ? (
                                            <List component="nav" className={classes.list} key={key} tabIndex={2}>
                                                {this.renderSubHeader(g)}
                                                <RequestErrorReport error={g.loaderError} />
                                            </List>
                                        )
                                        : g.items.length == 0 && g.groupButton
                                            ? (
                                                <List component="nav" className={classes.list} key={key} tabIndex={2}>
                                                    {g.group && this.renderSubHeader(g)}
                                                </List>
                                            )
                                            : g.items.length > 0
                                                ? (
                                                    <List component="nav" className={classes.list} key={key} tabIndex={2}>
                                                        {g.group && this.renderSubHeader(g)}
                                                        {this.renderGroup(g, activeRoute)}
                                                    </List>
                                                )
                                                : null;
                            })
                        }
                    </div>
                </PerfectScrollbar>
            </Drawer>
        );
    }

    //
    private startCalloutMonitoring() {
        coreApi.getCalloutNotification().then((data) => {
            if (data && data.length > 0) this.props.updateAppCallouts(data);
            this.counterTimer = setTimeout(() => { this.startCalloutMonitoring(); }, 60000);
        });
    }

    //
    private endCalloutMonitoring() {
        if (this.counterTimer) {
            clearTimeout(this.counterTimer);
            this.counterTimer = null;
        }
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////

    public componentDidMount() {
        this.wml = new SidebarWindowMessageListener(this.props.executeSideBarMessage);

        if (this.props.sidebar.menuData.length == 0) {
            this.props.load();
        }
        else {
            this.setActiveMenu(this.props);
        }

        if (this.counterTimer == null) {
            this.counterTimer = setTimeout(() => { this.startCalloutMonitoring(); }, 3000);
        }
    }

    public componentWillMount() {
        i18next.on('languageChanged', () => {
            this.props.reset();
        });
    }

    public componentWillUnmount() {
        this.endCalloutMonitoring();
        this.wml.dettach();
    }

    public componentDidUpdate(prevProps: Props) {
        this.applySidebarMargin(this.bellowMinWidth());
    }

    public componentWillReceiveProps(newProps: Props) {
        if (newProps.path != this.props.path || newProps.sidebar != this.props.sidebar) {
            this.setActiveMenu(newProps);
            this.lockedActiveMenu = false;
        }
    }

    public render() {
        if (this.props.sidebar.menuData.length == 0)
            return null;

        const { classes } = this.props;
        const leftMenu = this.getLeftMenu(this.state.activeMenu && this.state.activeMenu.left ? this.state.activeMenu.left.navbarName : null);
        const rightDrawer = this.getFloatMenu(this.state.activeMenu);

        return (
            <>
                {this.state.dialog}

                <ClickAwayListener onClickAway={(e) => this.handleClickOuter(e)}>

                    <div>
                        <Drawer
                            color="primary"
                            variant="permanent"
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                        >
                            <Grid container direction="column" style={{ height: "100%" }}>
                                <Grid item className={GlobalClassKeys.grow}>
                                    {leftMenu}
                                </Grid>
                                <Grid item >
                                    <List className={classes.list}>
                                        <ListItem
                                            button
                                            disableGutters
                                            className={classes.listItem}
                                            title={this.props.t("Common.Menu.Sidebar.Literals.QrCode")}
                                            onClick={this.handleQrCode}
                                        >
                                            <ListItemIcon className={classes.activeRouteText}>
                                                <IconQRCode />
                                            </ListItemIcon>
                                        </ListItem>
                                    </List>
                                </Grid>

                            </Grid>

                        </Drawer>

                        {rightDrawer}
                    </div>
                </ClickAwayListener>

                <ReactResizeDetector handleWidth handleHeight onResize={(w, h) => this.handleResize(w, h)} refreshMode="debounce" refreshRate={0}/>
            </>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

function mapStateToProps(state: ApplicationState): IStateProps {
    return {
        sidebar: state.sidebar
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<ApplicationState, void, Action>): IDispatchProps {
    return bindActionCreators({ ...SideBarActions, ...AppActions }, dispatch);
}

export default connect<IStateProps, IDispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(withStyles(sidebarStyle)(Sidebar)));
